import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_settings/einstellungen/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$company/unternehmen/einstellungen/bank",
      params: { company: params.company },
      replace: true,
    });
  },
});
